import React, { useMemo } from 'react';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import Picker from 'rc-picker';
import './style.less';
import classNames from 'classnames';
import CancelIcon from '@material-ui/icons/Cancel';
import usePickerLocale from 'src/components/Inputs/CaPicker/hooks/usePickerLocale';
import usePickerStyle from 'src/components/Inputs/CaPicker/hooks/usePickerStyle';
function CaPicker({ className, dropdownClassName, popupStyle, changeOnBlur = true, suffixAsInnerIcon, ...props }) {
    const classes = usePickerStyle({
        withClearIcon: !!props.allowClear
    });
    const pickerLocale = usePickerLocale();
    const classList = useMemo(() => classNames(className, classes.picker, suffixAsInnerIcon && classes.withSuffixIcon, suffixAsInnerIcon && 'suffix-as-inner-icon'), [className, classes, suffixAsInnerIcon]);
    return (React.createElement(Picker, { key: pickerLocale.locale, picker: props.picker, generateConfig: dateFnsGenerateConfig, locale: pickerLocale, changeOnBlur: changeOnBlur, popupStyle: { zIndex: 9999, ...popupStyle }, className: classList, dropdownClassName: classNames(classes.dropdown, dropdownClassName), clearIcon: React.createElement(CancelIcon, null), ...props }));
}
export default CaPicker;
